import { useQuery } from '@tanstack/react-query';
import { fetchYourTitlesCreditsSummary } from './fetchYourTitlesCreditsSummary';

const YOUR_TITLES_CREDITS_SUMMARY_QUERY_KEY = 'yourTitlesCreditsSummary';
export const useYourTitlesCreditSummary = () => {
    return useQuery([YOUR_TITLES_CREDITS_SUMMARY_QUERY_KEY], fetchYourTitlesCreditsSummary);
};
